<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Auditoria</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Usuarios</span>
      <span> /</span>
      <span>Auditoria</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <div class="card-body justify-content-between">
    <div class="filtros-body">
      <div class="row">
        <div class="col">
          <div class="md-form">
            <input
              value=""
              type="text"
              id="buscar"
              class="form-control"
              placeholder="12345678-1"
              required
              #buscar
            />
            <label for="vecodigo">Usuario</label>
          </div>
        </div>
        <button
          mdbBtn
          type="button"
          class="btn-cuadrado"
          color="secondary"
          mdbWavesEffect
        >
          <mdb-icon fas icon="search"></mdb-icon>
        </button>
        <div class="col p-4">
          <strong style="white-space: nowrap; font-weight: 600;" class="p-4"
            >Nombre del usuario</strong
          >
        </div>

        <div class="col">
          <div class="md-form">
            <mdb-date-picker
              [inline]="true"
              name="fechaInicio"
              [placeholder]="'Fecha inicio'"
              required
            ></mdb-date-picker>
          </div>
        </div>

        <div class="col">
          <div class="md-form">
            <mdb-date-picker
              [inline]="true"
              name="fechaFinal"
              [placeholder]="'Fecha final'"
              required
            ></mdb-date-picker>
          </div>
        </div>

        <div class="col">
          <div class="md-form">
            <mdb-select
              label="Modulo"
              [options]="optionsModulo"
              placeholder="Modulo"
              [filterEnabled]="true"
            ></mdb-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Modulo</th>
            <th scope="col">Usuario</th>
            <th scope="col">Operación</th>
            <th scope="col">Maquina</th>
            <th scope="col">Fecha</th>
            <th scope="col">Hora</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>263</td>
            <td>Facturación electrónica</td>
            <td>Pedro Ortega</td>
            <td>Consulta de documentos</td>
            <td>Maquina 1</td>
            <td>12 mayo 2019</td>
            <td>09:56</td>
          </tr>

          <tr>
            <td>263</td>
            <td>Facturación electrónica</td>
            <td>Pedro Ortega</td>
            <td>Consulta de documentos</td>
            <td>Maquina 1</td>
            <td>12 mayo 2019</td>
            <td>09:56</td>
          </tr>

          <tr>
            <td>263</td>
            <td>Facturacion electronica</td>
            <td>Pedro Ortega</td>
            <td>Consulta de documentos</td>
            <td>Maquina 1</td>
            <td>12 mayo 2019</td>
            <td>09:56</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
